var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNoBookings = function SvgNoBookings(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 200,
    viewBox: "0 0 262 200",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7982_167670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.92 120H0.577637V29.0411H152.92V120Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.106 119.747H0.303711V28.1305H153.106V119.747ZM2.01395 118.041H151.396V29.8373H2.01395V118.041Z",
    fill: "#DCDDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84424 40.2291V108.277H144.565V40.2291H8.84424ZM143.913 57.0783H110.798V40.8803H143.913V57.0783ZM77.031 57.0783V40.8803H110.146V57.0783H77.031ZM110.146 57.7295V73.9275H77.031V57.7295H110.146ZM76.3785 57.0783H43.2639V40.8803H76.3785V57.0783ZM76.3785 57.7295V73.9275H43.2639V57.7295H76.3785ZM42.6114 73.9275H9.49674V57.7295H42.6114V73.9275ZM42.6114 74.5787V90.7767H9.49674V74.5787H42.6114ZM43.2639 74.5787H76.3785V90.7767H43.2639V74.5787ZM76.3785 91.4279V107.626H43.2639V91.4279H76.3785ZM77.031 91.4279H110.146V107.626H77.031V91.4279ZM77.031 90.7767V74.5787H110.146V90.7767H77.031ZM110.798 74.5787H143.913V90.7767H110.798V74.5787ZM110.798 73.9275V57.7295H143.913V73.9275H110.798ZM42.6114 40.8803V57.0783H9.49674V40.8803H42.6114ZM9.49674 91.4279H42.6114V107.626H9.49674V91.4279ZM110.798 107.626V91.4279H143.913V107.626H110.798Z",
    fill: "#DCDDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.696 199.611C261.696 199.662 261.686 199.712 261.667 199.76C261.647 199.807 261.619 199.849 261.583 199.885C261.547 199.921 261.504 199.95 261.457 199.969C261.409 199.989 261.359 199.999 261.308 199.999H50.128C50.025 199.999 49.9263 199.958 49.8535 199.885C49.7806 199.812 49.7397 199.714 49.7397 199.611C49.7397 199.508 49.7806 199.41 49.8535 199.337C49.9263 199.264 50.025 199.224 50.128 199.224H261.308C261.411 199.224 261.509 199.265 261.582 199.337C261.655 199.41 261.696 199.508 261.696 199.611Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.278 191.647L176.87 191.647L174.773 174.678L181.279 174.678L181.278 191.647Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.65 200H180.522L179.963 197.053L178.533 200H170.237C169.839 200 169.452 199.873 169.132 199.638C168.812 199.403 168.575 199.072 168.457 198.693C168.338 198.314 168.344 197.907 168.474 197.532C168.604 197.157 168.85 196.833 169.177 196.607L175.803 192.041V189.062L182.771 189.477L183.65 200Z",
    fill: "#1B1B1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.475 187.17L204.603 189.273L194.634 175.368L200.349 172.265L208.475 187.17Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.559 193.376L211.811 194.868L209.909 192.546L210.065 195.817L202.777 199.774C202.428 199.964 202.027 200.037 201.633 199.983C201.239 199.929 200.873 199.751 200.587 199.475C200.302 199.199 200.112 198.838 200.047 198.447C199.981 198.056 200.042 197.654 200.222 197.299L203.854 190.128L202.427 187.511L208.747 184.552L214.559 193.376Z",
    fill: "#1B1B1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.701 153.397L196.416 179.667L203.595 174.574L187.965 142.519L177.701 153.397Z",
    fill: "#F9A87A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M177.701 153.397L196.416 179.667L203.595 174.574L187.965 142.519L177.701 153.397Z",
    fill: "#1B1B1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.136 185.604H174.026V153.23L168.386 132.123C164.338 117.029 163.262 101.294 165.218 85.7912L165.226 85.7278L165.275 85.6868C165.42 85.5653 179.855 73.654 188.985 82.766C195.14 88.908 189.357 110.993 189.033 112.205V150.278L183.136 185.604Z",
    fill: "#F9A87A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.172 30.1294C182.094 30.1294 186.896 25.3379 186.896 19.4273C186.896 13.5167 182.094 8.72522 176.172 8.72522C170.249 8.72522 165.448 13.5167 165.448 19.4273C165.448 25.3379 170.249 30.1294 176.172 30.1294Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5 28.5H180.5L181 33L172 33.5L173.5 28.5Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.879 18.904C216.526 21.0959 213.661 22.0622 211.119 21.6233C208.577 21.1845 206.368 19.5472 204.737 17.553C203.105 15.5588 201.977 13.2114 200.866 10.8878C199.756 8.56419 198.632 6.21504 197.009 4.21424C195.386 2.21341 193.189 0.563546 190.651 0.104007C189.269 -0.146084 187.705 0.0190271 186.697 0.994308C186.002 1.72531 185.623 2.69944 185.64 3.70689C185.201 3.55254 184.731 3.5084 184.27 3.57836C183.81 3.64833 183.374 3.83025 183 4.10808C182.627 4.38592 182.328 4.75115 182.129 5.17157C181.931 5.59199 181.839 6.05471 181.862 6.51892C181.824 6.5182 181.787 6.51572 181.749 6.51572C177.02 3.83233 169.841 5.39116 169.841 8.32146C167.246 8.32146 164.075 10.879 164.075 14.7628V14.7628C169.441 14.7628 172.599 21.6245 169.466 26.5444C168.658 27.7993 167.766 28.9991 166.798 30.1359H173.508C174.071 29.3297 174.411 28.3895 174.493 27.4103C174.739 28.2999 174.887 29.214 174.932 30.1359C174.932 30.1359 193.263 32.4931 188.531 14.2592C188.845 14.2436 189.149 14.1515 189.418 13.991C190.133 13.5613 190.522 12.6525 190.59 11.7304C190.767 11.7776 190.943 11.8246 191.119 11.8716C192.38 12.2113 193.69 12.6516 194.555 13.6279C196.018 15.2781 195.711 17.7827 196.242 19.9213C196.883 22.5003 198.799 24.5863 200.928 26.1818C203.215 27.8961 205.888 29.1985 208.735 29.4688C211.583 29.7392 214.613 28.875 216.586 26.8081C218.56 24.7412 219.247 21.4116 217.879 18.904Z",
    fill: "#1B1B1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.873 94.6453C149.339 94.5309 149.774 94.3159 150.148 94.0156C150.521 93.7153 150.824 93.3369 151.035 92.9071C151.246 92.4773 151.36 92.0066 151.369 91.528C151.378 91.0494 151.282 90.5747 151.087 90.1373L159.602 82.1899L153.712 80.7771L146.529 88.5407C145.814 88.9158 145.262 89.5394 144.977 90.2936C144.693 91.0477 144.695 91.8798 144.984 92.6323C145.273 93.3847 145.829 94.0053 146.545 94.3763C147.262 94.7473 148.091 94.843 148.873 94.6453H148.873Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.272 88.2436L149.301 82.6561L164.217 67.2601L167.68 42.9922C167.851 41.7927 168.285 40.6455 168.95 39.632C169.616 38.6186 170.497 37.7637 171.53 37.1282C172.564 36.4927 173.725 36.0921 174.932 35.9549C176.138 35.8176 177.36 35.9471 178.51 36.334C180.588 37.0353 182.301 38.5303 183.276 40.491C184.25 42.4517 184.405 44.718 183.706 46.7926L174.87 72.9563L153.272 88.2436Z",
    fill: "#FFDECB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.443 91.672L165.38 62.3691C164.998 61.57 159.507 56.5085 165.249 47.6093L171.45 33.0823L183.064 32.9022L183.113 32.951C185.845 35.6718 187.86 39.0249 188.978 42.7115C190.097 46.398 190.284 50.3035 189.523 54.0798L186.101 71.156L189.066 82.9924L162.443 91.672Z",
    fill: "#FFDECB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M173.536 58.1364L176.472 75.7181L173.536 87.9999L168 89.9999L170.333 75.7181L173.536 58.1364Z",
    fill: "#1B1B1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.337 105.466C176.694 105.146 176.977 104.752 177.164 104.311C177.352 103.871 177.441 103.395 177.424 102.916C177.408 102.438 177.286 101.969 177.069 101.543C176.851 101.116 176.542 100.743 176.164 100.448L179.926 89.4359L174.063 90.9574L171.389 101.182C170.935 101.848 170.743 102.658 170.847 103.457C170.952 104.256 171.346 104.989 171.956 105.517C172.566 106.045 173.349 106.332 174.157 106.322C174.964 106.313 175.74 106.008 176.337 105.466Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.198 97.7511L171.058 94.6876L176.954 74.0963L168.559 51.0593C168.145 49.9206 167.986 48.7047 168.095 47.4979C168.204 46.2912 168.578 45.1231 169.19 44.0767C169.802 43.0304 170.637 42.1313 171.637 41.4434C172.636 40.7555 173.775 40.2956 174.973 40.0963C177.136 39.7389 179.354 40.2526 181.138 41.5246C182.923 42.7967 184.129 44.7232 184.491 46.8815L189.04 74.1157L177.198 97.7511Z",
    fill: "#FFDECB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.7207,
    y: 42,
    width: 14.3551,
    height: 14.9771,
    rx: 2,
    fill: "#8E9BB5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.907,
    y: 92.1415,
    width: 14.3551,
    height: 14.9771,
    rx: 2,
    fill: "#8E9BB5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.7207,
    y: 92.1415,
    width: 14.3551,
    height: 14.9771,
    rx: 2,
    fill: "#8E9BB5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.6299,
    y: 58.605,
    width: 14.3551,
    height: 14.9771,
    rx: 2,
    fill: "#1D386C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.1377,
    y: 75.2109,
    width: 14.3551,
    height: 14.9771,
    rx: 2,
    fill: "#1D386C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7982_167670"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 261.392,
    height: 200,
    fill: "white",
    transform: "translate(0.303711)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoBookings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-bookings.63eda3f0.svg";
export { ForwardRef as ReactComponent };